import React, { useState } from 'react';
import { Modal, Form, Radio, message, Typography, Divider } from 'antd';
import { adminTasksApi } from '../../../services/api/adminTasks';
import { AdminTaskType } from '../../../types';

const { Text } = Typography;

interface AutoCloneProcessConfigModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  storyId: string;
  processId: string;
  processName: string;
}

const AutoCloneProcessConfigModal: React.FC<AutoCloneProcessConfigModalProps> = ({
  visible,
  onCancel,
  onSuccess,
  storyId,
  processId,
  processName,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const detail = {
        input: {
          sourceStoryId: storyId,
          parentProcessId: processId,
          panelMediaType: values.panelMediaType,
        },
        progress: 0,
        process: {},
        targetId: storyId,
      };

      await adminTasksApi.createTask({
        type: AdminTaskType.AUTO_CLONE_PROCESS,
        detail: detail as any,
      });

      message.success(`Đã khởi tạo tiến trình Auto Clone cho "${processName}" thành công!`);
      onSuccess();
    } catch (error: any) {
      if (error?.errorFields) {
        return;
      }
      console.error('Failed to create auto clone process task:', error);
      message.error('Không thể khởi tạo tiến trình: ' + (error.message || 'Lỗi không xác định'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={<span>🔄 Auto Clone & Process - <b>{processName}</b></span>}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={500}
      okText="Bắt đầu"
      cancelText="Hủy"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          panelMediaType: 'IMAGE',
        }}
      >
        <div style={{ marginBottom: '16px' }}>
          <Text type="secondary">
            Hệ thống sẽ tự động clone process này sang bản SHORT (9:16), copy nhân vật và thực hiện toàn bộ visual pipeline (scenes, panels, visual planning, media generation).
          </Text>
        </div>

        <Divider orientation={"left" as any}>Cấu hình Media</Divider>

        <Form.Item
          name="panelMediaType"
          label="Loại Media ưu tiên cho Panel"
          rules={[{ required: true, message: 'Vui lòng chọn loại media' }]}
        >
          <Radio.Group>
            <Radio value="IMAGE">Chỉ dùng Ảnh (Nhanh)</Radio>
            <Radio value="VIDEO">Ưu tiên Video (Đẹp nhưng lâu)</Radio>
            <Radio value="MIX">Mix Ảnh & Video (Tự động)</Radio>
          </Radio.Group>
        </Form.Item>

        <Text type="secondary" style={{ fontSize: '12px' }}>
          * Lưu ý: Luồng này sẽ tự động trích xuất lại scenes/panels phù hợp với định dạng dọc.
        </Text>
      </Form>
    </Modal>
  );
};

export default AutoCloneProcessConfigModal;
